import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

type SetIndex = { id: string; name: string; slug: string; count: number };

export default function SetHub() {
  const { slug } = useParams();
  const [setInfo, setSetInfo] = useState<SetIndex | null>(null);
  const [cards, setCards] = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      if (!slug) return;
      const idx = await fetch('/cards/index.json').then((r) => r.json());
      const info = (idx as SetIndex[]).find((s) => s.slug === slug) || null;
      setSetInfo(info);
      const data = await fetch(`/cards/${slug}.json`).then((r) => r.json());
      setCards(data.slice(0, 50));
    })();
  }, [slug]);

  if (!slug) return <div className="p-6 text-white">Set not found.</div>;

  return (
    <div className="p-6 text-white max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-2">{setInfo?.name || slug}</h1>
      <div className="opacity-80 text-sm mb-4">{setInfo?.count ?? cards.length} cards</div>

      <div className="grid grid-cols-2 md:grid-cols-8 gap-2">
        {cards.map((c) => (
          <Link key={c.id} to={`/card/${encodeURIComponent(c.id)}`} className="bg-white/10 rounded overflow-hidden aspect-[2/3]">
            <img src={c.images?.small} alt={c.name} className="w-full h-full object-cover" />
          </Link>
        ))}
      </div>
    </div>
  );
}


